import React from 'react';

const CenteredVideo: React.FC = () => {
    return (
      <div className="rounded-lg outline outline-4 outline-faded-back bg-faded-back intrinsic-container intrinsic-container-16x9 ">
        <iframe src="https://www.youtube.com/embed/jXm8WbFk0y0?si=vPB39vQ4-m21aHN4" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
      </div>
    );
  };
  

export default CenteredVideo;
